module.exports = __webpack_public_path__ + "static/media/toggle_up_on.ebff1268.svg";